import React from "react";
import PropTypes from "prop-types";
import { VIEW_COLUMNS } from "../../../../config/buildingColumnsConfig";

const ViewBuildingRow = ({ building, selectedBuilding, onRowClick }) => {
  const isSelected =
    selectedBuilding && selectedBuilding.buildingID === building.buildingID;
  return (
    <tr
      onClick={() => onRowClick(building)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      {VIEW_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.render ? col.render(building) : building[col.key]}
        </td>
      ))}
    </tr>
  );
};

ViewBuildingRow.propTypes = {
  building: PropTypes.object.isRequired,
  selectedBuilding: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
};

export default ViewBuildingRow;
